var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.allowedValues.range ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "step": "1",
      "hint": "hint",
      "persistent-hint": "",
      "persistent-placeholder": "",
      "placeholder": "0",
      "min": _vm.allowedValues.range.min,
      "max": _vm.maxConstrained,
      "disabled": _vm.allowedValues.range.min > _vm.max,
      "rules": [function (v) {
        return !!v || 'Invalid value';
      }, function (v) {
        return parseInt(v) >= _vm.allowedValues.range.min && parseInt(v) <= _vm.maxConstrained || 'Invalid value';
      }],
      "value": String(_vm.value)
    },
    on: {
      "input": function (x) {
        return _vm.$emit('input', x ? parseInt(x) : x);
      },
      "keydown": function (x) {
        if (/[\.,]/.test(x.key)) x.preventDefault();
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('currency', {
          staticClass: "mt-1",
          attrs: {
            "code": _vm.cur
          }
        })];
      },
      proxy: true
    }, {
      key: "message",
      fn: function () {
        return [_vm.allowedValues.range.min > _vm.max ? [_vm._v(" Max overall gift card value reached ")] : [_c('currency', {
          attrs: {
            "code": _vm.cur
          }
        }), _vm._v(_vm._s(_vm.allowedValues.range.min) + " – "), _c('currency', {
          attrs: {
            "code": _vm.cur
          }
        }), _vm._v(_vm._s(_vm.maxConstrained) + " ")]];
      },
      proxy: true
    }], null, false, 2738004650)
  }) : _vm.allowed.length == 0 ? _c('div', {
    staticClass: "text--label-active error--text"
  }, [_vm._v(" Max overall gift card value reached ")]) : _c('v-input', {
    attrs: {
      "error": !_vm.allowed.includes(_vm.value)
    }
  }, [_c('v-row', _vm._l(_vm.allowed, function (v) {
    return _c('v-col', {
      key: v,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-btn', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "input-value": _vm.value == v
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('input', v);
        }
      }
    }, [_c('currency', {
      attrs: {
        "code": _vm.cur
      }
    }), _vm._v(_vm._s(v) + " ")], 1)], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }